import React from "react";
import BaseSection from "../components/BaseSection";
import { IoMdSettings } from "react-icons/io";
import { Grid } from "@material-ui/core";
import * as dateFNS from "date-fns";
import TextInput from "../components/Input/TextInput";
import SwitchInput from "../components/Input/SwitchInput";
import { SwitchInputHelperText } from "./styles";

export const GENERAL_SECTION_INPUTS = {
  COMPANY_NAME: "company_name",
  TOTAL_LICENSES: "total_licenses",
  TOTAL_COLLABORATORS: "total_collaborators",
  URL: "url",
  ACCESS_PERIOD: "access_period",
  IS_ACTIVE: "is_active",
  STATUS: "status",
  RESTRICTED_COURSES: "restricted_courses",
  DESCRIPTION: "description",
};

export default function GeneralDataSection({
  inputs = {},
  errors = {},
  isEditing = false,
  onChangeInput = () => null,
}) {
  return (
    <BaseSection title="Informações gerais" Icon={<IoMdSettings />}>
      <Grid container spacing={3}>
        <Grid item container spacing={3}>
          <Grid item xs={isEditing ? 6 : 8}>
            <TextInput
              label="Empresa"
              type="text"
              placeholder="Nome da empresa"
              name={GENERAL_SECTION_INPUTS.COMPANY_NAME}
              value={inputs[GENERAL_SECTION_INPUTS.COMPANY_NAME]}
              errorMessage={errors[GENERAL_SECTION_INPUTS.COMPANY_NAME]}
              onChange={(e) =>
                onChangeInput(
                  GENERAL_SECTION_INPUTS.COMPANY_NAME,
                  e.target.value
                )
              }
            />
          </Grid>
          <Grid item xs={isEditing ? 3 : 4}>
            <TextInput
              label="Licenças disponíveis"
              type="number"
              placeholder="Número de licenças disponíveis"
              min={0}
              name={GENERAL_SECTION_INPUTS.TOTAL_LICENSES}
              value={inputs[GENERAL_SECTION_INPUTS.TOTAL_LICENSES]}
              errorMessage={errors[GENERAL_SECTION_INPUTS.TOTAL_LICENSES]}
              onChange={(e) =>
                onChangeInput(
                  GENERAL_SECTION_INPUTS.TOTAL_LICENSES,
                  e.target.value
                )
              }
            />
          </Grid>
          {isEditing && (
            <Grid item xs={3}>
              <TextInput
                label="Total de colaboradores no painel"
                type="number"
                placeholder="Número de colaboradores no painel"
                min={0}
                readOnly
                name={GENERAL_SECTION_INPUTS.TOTAL_COLLABORATORS}
                value={inputs[GENERAL_SECTION_INPUTS.TOTAL_COLLABORATORS]}
                errorMessage={
                  errors[GENERAL_SECTION_INPUTS.TOTAL_COLLABORATORS]
                }
                onChange={(e) =>
                  onChangeInput(
                    GENERAL_SECTION_INPUTS.TOTAL_COLLABORATORS,
                    e.target.value
                  )
                }
              />
            </Grid>
          )}
        </Grid>
        <Grid item container spacing={3}>
          <Grid item xs={6}>
            <TextInput
              label="URL do painel"
              type="text"
              placeholder="URL"
              endLabel=".voitto.com.br"
              helperText="A URL não deve conter caracteres especiais, pontuação, acentos, www, incompany, painel-empresa ou blogs"
              name={GENERAL_SECTION_INPUTS.URL}
              value={inputs[GENERAL_SECTION_INPUTS.URL]}
              errorMessage={errors[GENERAL_SECTION_INPUTS.URL]}
              onChange={(e) =>
                onChangeInput(GENERAL_SECTION_INPUTS.URL, e.target.value)
              }
            />
          </Grid>
          <Grid item container xs={6} spacing={3}>
            <Grid item xs={6}>
              <TextInput
                label="Prazo de acesso"
                type="date"
                name={GENERAL_SECTION_INPUTS.ACCESS_PERIOD}
                value={inputs[GENERAL_SECTION_INPUTS.ACCESS_PERIOD]}
                errorMessage={errors[GENERAL_SECTION_INPUTS.ACCESS_PERIOD]}
                min={dateFNS.format(
                  dateFNS.addDays(new Date(), 1),
                  "yyyy-MM-dd"
                )}
                onChange={(e) =>
                  onChangeInput(
                    GENERAL_SECTION_INPUTS.ACCESS_PERIOD,
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={6}>
              <SwitchInput
                label="Status da empresa"
                name={GENERAL_SECTION_INPUTS.STATUS}
                text={
                  inputs[GENERAL_SECTION_INPUTS.STATUS] === "active"
                    ? "ATIVO"
                    : "INATIVO"
                }
                checked={inputs[GENERAL_SECTION_INPUTS.STATUS] === "active"}
                onChange={(e) =>
                  onChangeInput(
                    GENERAL_SECTION_INPUTS.STATUS,
                    e.target.checked ? "active" : "inactive"
                  )
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item xs={9}>
            <TextInput
              label="Descrição (Opcional)"
              name={GENERAL_SECTION_INPUTS.DESCRIPTION}
              value={inputs[GENERAL_SECTION_INPUTS.DESCRIPTION]}
              errorMessage={errors[GENERAL_SECTION_INPUTS.DESCRIPTION]}
              maxLength={64}
              onChange={(e) =>
                onChangeInput(
                  GENERAL_SECTION_INPUTS.DESCRIPTION,
                  e.target.value
                )
              }
            />
          </Grid>
          <Grid item xs={3}>
            <SwitchInput
              label="Painel com cursos restritos?"
              name={GENERAL_SECTION_INPUTS.RESTRICTED_COURSES}
              text={
                inputs[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES] === "yes"
                  ? "SIM"
                  : "NÃO"
              }
              checked={
                inputs[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES] === "yes"
              }
              onChange={(e) =>
                onChangeInput(
                  GENERAL_SECTION_INPUTS.RESTRICTED_COURSES,
                  e.target.checked ? "yes" : "no"
                )
              }
            />
            {inputs[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES] === "yes" && (
              <SwitchInputHelperText>
                Ao desmarcar essa opção, o cursos previamente selecionados serão
                removidos
              </SwitchInputHelperText>
            )}
          </Grid>
        </Grid>
      </Grid>
    </BaseSection>
  );
}
